import NotificationsTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import PrimaryButton from 'components/form/buttons/primaryButton';
import AppLoading from 'components/appLoading';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function NotificationsPage() {
  const { notificationsCustom }: any = useTypedSelector((state) => state.Notifications);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      <PageTitle title="Notifications" />
      <S.Head>
        <PrimaryButton link="/panel/notifications/create">
          <PlusIcon />
          New notification
        </PrimaryButton>
      </S.Head>
      <NotificationsTable data={notificationsCustom.data} departments={departments.data} loading={false} />

      <AppLoading loading={departments.loading || notificationsCustom.loading} />
    </S.Container>
  );
}
